import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertTriangle } from 'lucide-react';
import { formatDateTimeInTz } from '@/lib/propertyTime';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const DuplicateBookingsNotice = ({ timeZone, refreshKey }) => {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API_URL}/admin/reservations/duplicates`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setGroups(res.data))
      .catch(() => setGroups([]));
  }, [refreshKey]);

  if (groups.length === 0) return null;

  return (
    <div className="mb-6 border-2 border-amber-500 bg-amber-50 rounded-md p-4" data-testid="duplicate-bookings-notice">
      <div className="flex items-center gap-2 mb-2">
        <AlertTriangle className="w-5 h-5 text-amber-600" />
        <h3 className="font-serif font-medium text-lg text-[#1C1917]">
          {groups.length} chair{groups.length > 1 ? 's have' : ' has'} more than one active booking on the same day
        </h3>
      </div>
      <p className="text-sm text-[#78716C] mb-3">Please review and cancel the extra bookings. The earliest booking is listed first.</p>
      <div className="space-y-3">
        {groups.map((g) => (
          <div key={`${g.inventory_item_id}-${g.reservation_day}`} className="bg-white border border-amber-200 rounded-sm p-3" data-testid={`duplicate-group-${g.inventory_label}-${g.reservation_day}`}>
            <p className="font-medium text-sm mb-1">Seat {g.inventory_label} · {g.reservation_day}</p>
            <ul className="text-sm text-[#57534E] space-y-0.5">
              {[...g.reservations].sort((a, b) => String(a.created_at).localeCompare(String(b.created_at))).map((r) => (
                <li key={r.id}>
                  <span className="font-semibold text-[#9F1239]">{r.confirmation_code}</span> · {r.guest_name}
                  {r.room_number && <> · Room {r.room_number}</>} · {r.status.replace(/_/g, ' ')} · booked {formatDateTimeInTz(r.created_at, timeZone)}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};
